import { Box, Typography } from "@mui/material";
import { WasteManifestSource } from "generated-graphql/graphql";

import { SOURCE_LABEL, SOURCE_ORDER } from "./manifestSourceDisplay";

interface SourcesDisagreeTooltipProps {
  /** Per-source display values for the field; missing/blank sources are omitted. */
  values: Partial<Record<WasteManifestSource, string | null | undefined>>;
}

/**
 * Tooltip body for the "Sources disagree on this value" warning: the message
 * plus each source's reported value, so the reader sees the actual conflict.
 * Shared by the manifest-detail fields, the line-item modal, and the line-item
 * grid's Amount cell.
 */
export function SourcesDisagreeTooltip({ values }: SourcesDisagreeTooltipProps) {
  return (
    <Box>
      <Typography variant="caption" sx={{ fontWeight: 700, display: "block", mb: 0.25 }}>
        Sources disagree on this value
      </Typography>
      {SOURCE_ORDER.map((source) => {
        const value = values[source];
        if (value == null || value === "") return null;
        return (
          <Typography key={source} variant="caption" component="div">
            {SOURCE_LABEL[source]}: {value}
          </Typography>
        );
      })}
    </Box>
  );
}
